// The kinds of policy, in the order the dashboard shows them (the policy step of the onboarding
// wizard, My Policies, the policy selects): All approved, Auth email OTP, Blocked, then any other
// type. Each kind's description is said once, above its policies.
import { AVAILABLE_POLICIES } from './policies';

export const POLICY_GROUPS = [
  {
    key: 'approved',
    title: 'All approved',
    description: AVAILABLE_POLICIES.find((p) => p.id === 'no-verification')?.description ?? '',
  },
  {
    key: 'otp',
    title: 'Email authentication',
    description:
      'Email OTP for the initiator, or multi-party approval with additional validators.',
  },
  {
    key: 'blocked',
    title: 'Blocked',
    description: 'Every call is refused. A method left without a policy is blocked the same way.',
  },
  {
    key: 'other',
    title: 'Other',
    description: 'Policies of another type.',
  },
] as const;

export type PolicyGroupKey = (typeof POLICY_GROUPS)[number]['key'];

/** The kind of a policy, from its type as the backend names it (or the wizard's id for it). */
export function policyGroupOf(type: string | undefined): PolicyGroupKey {
  switch (type) {
    case 'PassThroughPolicy':
    case 'no-verification':
      return 'approved';
    case 'UserAuthenticationPolicy':
    case 'UserAuthenticationChecksDemoPolicy':
    case 'UserMultiAuthenticationPolicy':
    case 'email-otp':
    case 'multi-email-otp':
      return 'otp';
    case 'AllBlockedPolicy':
      return 'blocked';
    default:
      return 'other';
  }
}
